<template>
    <v-container>
        <h1 class="display-1">Create Scenario</h1>

        <v-card class="mt-4">
            <v-card-text>
                <v-text-field v-model="form.number"
                              type="number"
                              @keydown.enter="storeScenario"
                              label="Number"/>
                <v-text-field v-model="form.title"
                              @keydown.enter="storeScenario"
                              label="Name"/>
                <v-text-field v-model="form.requirements"
                              @keydown.enter="storeScenario"
                              label="Requirements (optional)"/>
                <v-btn color="secondary" @click="$router.push({name: 'campaign', params: {campaignId: $route.params.campaignId}})" class="mr-2">Cancel</v-btn>
                <v-btn color="primary" @click="storeScenario" :loading="loading">Create</v-btn>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import ScenarioService from "../services/ScenarioService";

  export default {
    data: () => ({
      loading: false,
      form: {
        number: null,
        title: null,
        requirements: null,
        campaign_id: null
      }
    }),

    methods: {
      storeScenario() {
        this.loading = true;
        this.form.campaign_id = this.$route.params.campaignId;

        ScenarioService.store(this.form)
          .then(() => {
            this.$router.push({name: 'campaign', params: {campaignId: this.$route.params.campaignId}});
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          });
      }
    }
  };
</script>
